import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { checkPolotnoType } from '@/pages/AdvancedEditor/utils';
import { reaction } from 'mobx';
import { useEffect } from 'react';

export const useSyncCurrentAvatar = () => {
    const { store } = useAdvancedEditorContext();

    // prevent multiple avatars
    useEffect(() => {
        const dispose = reaction(
            () => store.activePage?.children?.length,
            () => {
                if (!store.activePage) {
                    return;
                }

                const avatars = store.activePage.children.filter(child => checkPolotnoType(child, polotnoTypes.Avatar));
                const avatarsIds = avatars.map(a => a.id);

                const multipleAvatars = avatarsIds.length > 1;
                if (!multipleAvatars) return;

                // take the last avatar from array, remove rest
                avatarsIds.pop();

                const avatarsToRemove = avatarsIds;
                if (avatarsToRemove?.length) {
                    store.deleteElements(avatarsToRemove);
                }
            }
        );
        return () => {
            dispose();
        };
    }, []);
};
